import { RealEstateFilter, RealEstateItemKey, RealEstateListing } from './realEstate';

export interface PromotedContent {
	id?: string;
	title?: string;
	type: PromotedContentType;
	inactive?: boolean;
	open?: boolean;
	hasError?: boolean;
	errorMsg?: string;
}

export enum PromotedContentType {
	REAL_ESTATE_SINGLE_OFFER = 'REAL_ESTATE_SINGLE_OFFER',
	REAL_ESTATE_RECENT_OFFERS = 'REAL_ESTATE_RECENT_OFFERS',
	REAL_ESTATE_WIDGET = 'REAL_ESTATE_WIDGET',
	REAL_ESTATE_SEARCH_WIDGET = 'REAL_ESTATE_SEARCH_WIDGET',
	CARROUSEL = 'CARROUSEL',
	IMAGE_GRID = 'IMAGE_GRID',
	BANNER = 'BANNER',
	HTML = 'HTML',
	YOUTUBE_VIDEO = 'YOUTUBE_VIDEO',
	YOUTUBE_LIST = 'YOUTUBE_LIST',
	HOSTED_VIDEO = 'HOSTED_VIDEO',
	ATTACH_PDF = 'ATTACH_PDF',
	RICH_TEXT = 'RICH_TEXT'
}

export enum PromotedContentTypeOrder {
	REAL_ESTATE_SINGLE_OFFER = 0,
	REAL_ESTATE_RECENT_OFFERS = 1,
	REAL_ESTATE_WIDGET = 2,
	REAL_ESTATE_SEARCH_WIDGET = 3,
	CARROUSEL = 4,
	IMAGE_GRID = 5,
	BANNER = 6,
	HTML = 7,
	YOUTUBE_VIDEO = 8,
	YOUTUBE_LIST = 9,
	HOSTED_VIDEO = 10,
	ATTACH_PDF = 11,
	RICH_TEXT = 12
}

// TODO: Add Icons PDF and Rich Text
export function getPromotedContentTypeIcon(type: PromotedContentType): string {
	switch (type) {
		case PromotedContentType.CARROUSEL:
			return 'carrousel-icon.svg';
		case PromotedContentType.IMAGE_GRID:
			return 'image-grid-icon.svg';
		case PromotedContentType.BANNER:
			return 'banner-icon.svg';
		case PromotedContentType.REAL_ESTATE_SINGLE_OFFER:
			return 'real-estate-single-offer-icon.svg';
		case PromotedContentType.REAL_ESTATE_RECENT_OFFERS:
			return 'real-estate-recent-offers-icon.svg';
		case PromotedContentType.REAL_ESTATE_WIDGET:
			return 'real-estate-recent-offers-icon.svg';
		case PromotedContentType.HTML:
			return 'html-icon.svg';
		case PromotedContentType.YOUTUBE_VIDEO:
			return 'youtube-video-icon.svg';
		case PromotedContentType.YOUTUBE_LIST:
			return 'youtube-list-icon.svg';
		case PromotedContentType.HOSTED_VIDEO:
			return 'hosted-video-icon.svg';
		case PromotedContentType.REAL_ESTATE_SEARCH_WIDGET:
			return 'real-estate-search-widget-icon.svg';
		case PromotedContentType.ATTACH_PDF:
			return 'pdf-icon.svg';
		case PromotedContentType.RICH_TEXT:
			return 'rich-text-icon.svg';
	}
}

export interface ImageContent {
	imageUrl?: string;
	destinationUrl?: string;
	inactive?: boolean;
}

export interface BannerPromotedContent extends PromotedContent {
	image: ImageContent;
}

export interface RealEstateSingleOfferPromotedContent extends PromotedContent {
	key: RealEstateItemKey;
	listing: RealEstateListing;
	filter: RealEstateFilter;
	autoUpdate?: boolean;
	layoutTemplate?: string;
}

export interface RealEstateRecentOffersPromotedContent extends PromotedContent {
	quantity: number;
	listings: RealEstateListing[];
	filter: RealEstateFilter;
	layoutTemplate?: string;
}

export interface RealEstateWidgetPromotedContent extends PromotedContent {
	widgetId: string;
	src: string;
}

export interface RealEstateWidget {
	id: string;
	name: string;
	src: string;
}

export interface RealEstateSearchWidgetPromotedContent extends PromotedContent {
	layoutTemplate?: string;
}

export interface RealStateFilterFeatures {
	slug: string;
	label: string;
	category: string;
}

export interface RealEstateFilterOffices {
	id: string;
	name: string;
}

export interface ImageGridPromotedContent extends PromotedContent {
	images: ImageContent[];
	imageGridType: ImageGridType;
}

export enum ImageGridType {
	SMALL = 'SMALL',
	BIG = 'BIG'
}

export function getImageGridTypeIcon(type: ImageGridType): string {
	switch (type) {
		case ImageGridType.BIG:
			return 'image-grid-big-icon.svg';
		case ImageGridType.SMALL:
			return 'image-grid-small-icon.svg';
	}
}

export interface CarrouselPromotedContent extends PromotedContent {
	images: ImageContent[];
	carrouselType: CarrouselType;
	staticCarrousel: boolean;
}

export enum CarrouselType {
	SQUARE = 'SQUARE',
	FULL = 'FULL'
}

export function getCarrouselTypeIcon(type: CarrouselType): string {
	switch (type) {
		case CarrouselType.FULL:
			return 'carrousel-full-icon.svg';
		case CarrouselType.SQUARE:
			return 'carrousel-square-icon.svg';
	}
}

export interface HtmlPromotedContent extends PromotedContent {
	html: string;
	writeInHead: boolean;
}

export interface YouTubeVideoPromotedContent extends PromotedContent {
	videoUrl: string;
	videoId: string;
}

export interface YouTubeListPromotedContent extends PromotedContent {
	listUrl: string;
	listId: string;
	videoIds: string[];
	listType: string;
	quantity: number;
}

export interface HostedVideoPromotedContent extends PromotedContent {
	videoUrl: string;
}

export interface AttachPDFPromotedContent extends PromotedContent {
	fileUrl: string;
	content?: string;
	buttonText: string;
}

export interface RichTextPromotedContent extends PromotedContent {
	content: string;
}
